import * as ng from 'angular';
import { ArchiSmallServices } from '../../../services/archismall.service';
import { AlertService } from '../../../services/ui/alert.service';
import { TableHeaderItem } from '../../../commons/components/table-component/domain/table-header-item';
import { FilterOptions } from '../../../domain/filter/filter-options';

export const AnagraficaComponent = {
    template: require('./anagrafica.html'),
    controller: class AnagraficaComponent {
        static $inject: string[] = [
            '$scope',
            'ArchiSmallServices',
            'AlertService',
            '$uibModal',
            'store'
        ];

        private tooltips: Record<string, string>;
        private pageHeader: string;

        private headerColumns: Array<TableHeaderItem>;

        private filter: Record<string, string | number>;
        private filterOptions: FilterOptions;

        private pageNumber: number;
        private pageSize: number;
        private pageSizes: Array<number>;

        private itemsCount: number;

        constructor(
            private $scope: any,
            private ArchiSmallServices: ArchiSmallServices,
            private alertService: AlertService,
            private $uibModal: ng.ui.bootstrap.IModalService,
            store: ng.a0.storage.IStoreService
        ) {
            this.tooltips = {
                'header': `Nella rubrica sono salvate automaticamente le informazioni dei\ncontatti utilizzati per la Fatturazione Elettronica e la Conservazione Digitale.\n
                            Puoi aggiungere, modificare o rimuovere i tuoi contatti.`,
                'cerca': 'Cerca un contatto dalla rubrica.',
                'nuovoContatto': 'Aggiungi un nuovo contatto.',
                'modificaContatto': 'Seleziona e modifica un contatto.',
                'eliminaContatto': 'Rimuovi un contatto.'
            };
            this.pageHeader = this.buildPageHeader(store.get('user'));

            this.headerColumns = [
                { key: 'company_name', label: 'Denominazione', ratio: '20', isSortable: false },
                { key: 'nome', label: 'Nome', ratio: '10', isSortable: false },
                { key: 'cognome', label: 'Cognome', ratio: '13', isSortable: false },
                { key: 'piva', label: 'Partita Iva', ratio: '16', isSortable: false },
                { key: 'fiscal_code', label: 'Codice Fiscale', ratio: '16', isSortable: false },
                { key: 'email_pec', label: 'PEC', ratio: '13', isSortable: false },
                { key: 'emails', label: 'Mail', ratio: '22', isSortable: false }
            ];

            this.filterOptions = new FilterOptions([
                { key: 'companyName', value: '', label: 'Denominazione' },
                { key: 'nome', value: '', label: 'Nome' },
                { key: 'cognome', value: '', label: 'Cognome' },
                { key: 'piva', value: '', label: 'Partita Iva' },
                { key: 'fiscalCode', value: '', label: 'Codice Fiscale' },
                { key: 'email', value: '', label: 'Email' }
            ]);

            $scope.countSelectedItemsFromCurrentPage = 0;
            $scope.moreDataToLoad = true;
            $scope.selectAllValue = false;
            $scope.selectedItems = [];
            let processingRequest = false;

            this.pageNumber = 1;
            this.pageSize = 100;
            this.pageSizes = [20, 50, 100];

            this.itemsCount = -1;

            $scope.clearFilter = () => {
                this.pageNumber = 1;
                $scope.getItems();
            };

            $scope.openAnagraficaFilterModal = (size) => {
                let modalInstance = $uibModal.open({
                    animation: true,
                    component: 'anagraficaFilterModalInstanceComponent',
                    size: size,
                    windowClass: 'center-modal',
                    backdrop: 'static',
                    keyboard: false,
                    resolve: {
                        filterOptions: () => {
                            return this.filterOptions;
                        }
                    }
                });

                modalInstance.result.then((filterOptions) => {
                    if (filterOptions !== undefined) {
                        this.filterOptions = filterOptions;
                        $scope.selectedItems = [];
                        this.pageNumber = 1;
                        $scope.getItems();
                    }
                });
            };

            $scope.openAnagraficaDetailModal = (itemScope) => {
                let item = undefined;
                // this method can be called by Modifica Button, or by context menu (right click), or by Nuovo Nominativo
                // we will try to modify the item that has been right clicked, or the selected item from current page, or create a new item

                if (itemScope === undefined) {
                    // this should happend only on Modifica button
                    if ($scope.countSelectedItemsFromCurrentPage === 1) {
                        for (let i = 0; i < $scope.items.length; i++) {
                            if ($scope.items[i].isSelected) {
                                item = jQuery.extend(true, {}, $scope.items[i]);
                                break;
                            }
                        }
                    } else {
                        return;
                    }
                } else {
                    if (itemScope === 'new') {
                        item = undefined;
                    } else {
                        item = jQuery.extend(true, {}, itemScope);
                    }
                }

                let anagraficaDetailModal = $uibModal.open({
                    animation: true,
                    component: 'anagraficaDetailModalComponent',
                    size: 'lg',
                    backdrop: 'static',
                    keyboard: false,
                    resolve: {
                        item: () => {
                            return item;
                        }
                    }
                });
                anagraficaDetailModal.result.then((response) => {
                    if (response) {
                        this.pageNumber = 1;
                        $scope.getItems();
                    }
                });
            };

            $scope.delete = (itemScope) => {
                let itemsSelected = [];
                // this method can be called by Rimuovi Button, or by context menu (right click)
                // we will try to delete all selected items, or the item that has been right clicked
                let msg: string;
                if ($scope.selectedItems.length > 0) {
                    itemsSelected = $scope.selectedItems;
                    msg = 'Confermi l’eliminazione dei contatti selezionati?';
                } else {
                    if (itemScope !== undefined) {
                        itemsSelected.push(itemScope._id);
                        msg = 'Confermi l’eliminazione di ' + itemScope.company_name + ' ?';
                    } else {
                        return;
                    }
                }

                let modalInstance = $uibModal.open({
                    animation: $scope.animationsEnabled,
                    component: 'defaultModalComponent',
                    windowClass: 'center-modal',
                    resolve: {
                        config: () => {
                            return {
                                headerText: 'Conferma Elimina',
                                bodyHtml: '<i class=\'fa fa-exclamation-triangle\'></i> ' + msg,
                                buttons: [
                                    {
                                        'id': 1,
                                        'icon': 'fa fa-ban',
                                        'label': 'Annulla'
                                    },
                                    {
                                        'id': 2,
                                        'icon': 'fa fa-check-circle-o',
                                        'label': 'Ok'
                                    }
                                ]
                            };
                        }
                    }
                });

                modalInstance.result.then((pressedButtonId) => {
                    if (pressedButtonId !== undefined && pressedButtonId === 2) {
                        if (itemsSelected.length > 0) {
                            ArchiSmallServices.deleteAnagrafica(itemsSelected)
                                .then((response) => {
                                    this.pageNumber = 1;
                                    $scope.getItems();
                                    $scope.selectedItems = [];
                                }, (error) => {
                                    this.alertService.alert('error', error);
                                });
                        }
                    }
                });
            };

            $scope.getItems = () => {
                if (processingRequest) {
                    return;
                }

                let filter = {
                    ...this.filterOptions.toRecord(),
                    pageNumber: this.pageNumber,
                    pageSize: this.pageSize
                };
                processingRequest = true;
                ArchiSmallServices.getAnagraficaItems(filter)
                    .then((response: any) => {
                        this.itemsCount = response.itemsCount;
                        let items = response.resultList;

                        $scope.items = items;
                        $scope.moreDataToLoad = true;

                        if ($scope.items.length >= this.itemsCount) {
                            $scope.moreDataToLoad = false;
                        }

                        processingRequest = false;
                    }, (error) => {
                        this.alertService.alert('error', error);
                        processingRequest = false;
                    });
            };

            $scope.getItems();

            $scope.clearSelection = () => {
                $scope.selectedItems = [];
                for (let i = 0; i < $scope.items.length; i++) {
                    $scope.items[i].isSelected = false;
                }
                $scope.selectAllValue = false;
                $scope.countSelectedItemsFromCurrentPage = 0;
            };

            let countSelectedItemsFromCurrentPage = () => {
                let count = 0;
                for (let i = 0; i < $scope.items.length; i++) {
                    if ($scope.items[i].isSelected) {
                        count++;
                    }
                }
                $scope.countSelectedItemsFromCurrentPage = count;
                return;
            };

            $scope.contextMenuItemTitle = '<span><strong class=\'centered\'>' + $scope.selectedItems.length + ' items selected</strong></span>';
            $scope.contextMenuOptions = (item) => {
                if ($scope.selectedItems.length > 1) {
                    $scope.menuOptionsMultiple[0][0] = '<span><strong>Anagrafica multipli (' + $scope.selectedItems.length + ')</strong></span>';
                    return $scope.menuOptionsMultiple;
                } else {
                    $scope.menuOptionsSingle[0][0] = '<span><strong>Documento ' + item.company_name + '</strong></span>';
                    return $scope.menuOptionsSingle;
                }
            };

            $scope.contextMenuItemNew = '<i class=\'icon-icon_rubrica\'></i> <span>Nuovo contatto</span>';
            $scope.contextMenuItemUpdate = '<i class=\'icon-icon_modifica\'></i> <span>Modifica contatto</span>';
            $scope.contextMenuItemRemove = '<i class=\'icon-icon_erase\'></i> <span>Rimuovi contatto</span>';
            $scope.menuOptionsSingle = [
                [$scope.contextMenuItemTitle, ($itemScope) => {
                    //
                }],
                null,
                [$scope.contextMenuItemNew, ($itemScope) => {
                    $scope.openAnagraficaDetailModal('new');
                }],
                null,
                [$scope.contextMenuItemUpdate, ($itemScope) => {
                    $scope.openAnagraficaDetailModal($itemScope.item);
                }],
                null,
                [$scope.contextMenuItemRemove, ($itemScope) => {
                    $scope.delete($itemScope.item);
                }]
            ];
            $scope.menuOptionsMultiple = [
                [$scope.contextMenuItemTitle, () => {
                    // title
                }],
                null,
                [$scope.contextMenuItemNew, ($itemScope) => {
                    $scope.openAnagraficaDetailModal('new');
                }],
                null,
                [$scope.contextMenuItemRemove, ($itemScope) => {
                    $scope.delete($itemScope.item);
                }]
            ];

            $scope.addOrRemoveSelectedItems = (item) => {
                if (item.isSelected) {
                    if ($scope.selectedItems.indexOf(item._id) === -1) {
                        $scope.selectedItems.push(item._id);
                    }

                    if ($scope.selectedItems.length === 1) {
                        $scope.selectedItem = item;
                    }
                } else {
                    if ($scope.selectedItems.length === 1) {
                        $scope.selectedItem = {};
                    }
                    let index = $scope.selectedItems.indexOf(item._id);
                    $scope.selectedItems.splice(index, 1);
                }
                countSelectedItemsFromCurrentPage();
            };
        }

        private buildPageHeader(user: any): string {
            let pageHeader = 'Rubrica di ';
            if (user.accountData.userType === 1) {
                pageHeader += user.organizationData.contactPerson.firstname;
            } else {
                pageHeader += user.organizationData.name;
            }
            return pageHeader;
        }
    }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/usersettings/anagrafica/anagrafica.ts